import { useTranslate } from '@tolgee/react';
import { Popover } from 'antd';
import dayjs from 'dayjs';
import { LogisticsContent } from 'views/Conversation/Sider/TradeDetail';
import { Trigger } from 'views/Conversation/Sider/TradeRefund';
import detailSvg from 'views/Aide/assets/more.svg';
import { useState } from 'react';
import { TradeListContext } from 'views/Conversation/Sider/TradeContext';
import { TradeContext } from 'views/Conversation/Sider/StateContext';
import styled from '@emotion/styled';
import { DetailImg } from 'views/Conversation/Sider/styles';

export const dateFormatter = (time: string | number) => dayjs(Number(time)).format('YYYY-MM-DD');

export function Logistics({
  platform,
  region,
  externalTradeId,
  logisticsList,
}: {
  platform: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  externalTradeId: string;
  logisticsList?: Conversation.Trade.Logistics[];
}) {
  const { t } = useTranslate();

  const [trade, setTrade] = useState<any>({
    platform,
    region,
    externalTradeId,
    logisticsList,
  });
  const [list, setList] = useState([trade]);

  if (!logisticsList?.length) {
    return <div>-</div>;
  }

  const [
    { leChatStatus, trackingInfo: [{ updateTime } = {}] = [], shippingCarrier, trackingNumber },
  ] = logisticsList;

  return (
    <Container>
      <div>{t(`leChatLogisticsStatus.${leChatStatus}`)}</div>
      {updateTime ? <div>{dateFormatter(Number(updateTime) * 1000)}</div> : null}
      <section>{shippingCarrier}</section>
      <section>
        <span>{trackingNumber}</span>
        <TradeListContext.Provider
          value={
            {
              list,
              setList,
              conversation: {
                channel: platform,
                region,
              },
            } as any
          }
        >
          <TradeContext.Provider
            value={{
              state: trade,
              setState: setTrade,
            }}
          >
            <Popover
              trigger="click"
              arrowPointAtCenter
              placement="bottomRight"
              content={
                <div onClick={(e) => e.stopPropagation()}>
                  <LogisticsContent
                    sendable={false}
                    platform="SHOPEE"
                    logisticsPackageList={list[0]?.logisticsList}
                    reportTranslation={false}
                  />
                </div>
              }
            >
              <Trigger onClick={(e) => e.stopPropagation()}>
                <DetailImg src={detailSvg} alt="detail" />
              </Trigger>
            </Popover>
          </TradeContext.Provider>
        </TradeListContext.Provider>
      </section>
    </Container>
  );
}

export function ReverseLogistics({
  platform,
  region,
  externalReturnId,
  externalTradeId,
  reverseLogisticsList,
}: {
  platform: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  externalReturnId: string;
  externalTradeId: string;
  reverseLogisticsList?: Conversation.Trade.ReverseLogistics[];
}) {
  const { t } = useTranslate();

  const [trade, setTrade] = useState<any>({
    platform,
    region,
    externalTradeId,
    reverseLogisticsList,
  });
  const [list, setList] = useState([trade]);

  const current = reverseLogisticsList?.filter((_) => _.externalReturnId === externalReturnId);

  if (!current?.length) {
    return <div>-</div>;
  }

  const [
    {
      leChatStatus,
      deliveryTimeMs,
      deliverySlaTimeMinMs,
      deliverySlaTimeMaxMs,
      shippingCarrier,
      trackingNumber,
    },
  ] = current;

  return (
    <Container>
      <div>{t(`leChatLogisticsStatus.${leChatStatus}`)}</div>
      {leChatStatus === 'LE_CHAT_SIGNED' ? (
        <div>
          {t('scene.orderWorkspace.returnRefundTab.detail.field.deliveredOnDate', {
            date: dateFormatter(deliveryTimeMs),
          })}
        </div>
      ) : Number(deliverySlaTimeMinMs) && Number(deliverySlaTimeMaxMs) ? (
        <div>
          {t('scene.orderWorkspace.returnRefundTab.detail.field.estimatedDeliveryDateRange', {
            date1: dateFormatter(deliverySlaTimeMinMs),
            date2: dateFormatter(deliverySlaTimeMaxMs),
          })}
        </div>
      ) : null}
      <section>{shippingCarrier}</section>
      <section>
        <span>{trackingNumber}</span>
        <TradeListContext.Provider
          value={
            {
              list,
              setList,
              conversation: {
                channel: platform,
                region,
              },
            } as any
          }
        >
          <TradeContext.Provider
            value={{
              state: trade,
              setState: setTrade,
            }}
          >
            <Popover
              trigger="click"
              arrowPointAtCenter
              placement="bottomRight"
              content={
                <div onClick={(e) => e.stopPropagation()}>
                  <LogisticsContent
                    isReverse
                    externalReturnId={externalReturnId}
                    sendable={false}
                    platform="SHOPEE"
                    logisticsPackageList={list[0]?.reverseLogisticsList}
                    reportTranslation={false}
                  />
                </div>
              }
            >
              <Trigger onClick={(e) => e.stopPropagation()}>
                <DetailImg src={detailSvg} alt="detail" />
              </Trigger>
            </Popover>
          </TradeContext.Provider>
        </TradeListContext.Provider>
      </section>
    </Container>
  );
}

const Container = styled.div`
  font-size: 12px;
  > div:first-of-type {
    font-size: 14px;
  }
  > section {
    color: var(--fett-text-tertiary);
    &:last-of-type {
      display: flex;
      align-items: center;
    }
  }
`;
